import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { MyWorkPage } from "../components/my-work/MyWorkPage";
import { myWorkSearchSchema } from "../components/my-work/my-work-search";

/** My work's Recently viewed (BUILD_SPEC §12.7), its peek's issue in the address. */
function Page() {
  const search = useSearch({ from: "/admin/my/recent" });
  const navigate = useNavigate({ from: "/admin/my/recent" });
  return (
    <MyWorkPage
      view="recent"
      search={search}
      onSearch={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }) })}
    />
  );
}

export const Route = createFileRoute("/admin/my/recent")({ validateSearch: myWorkSearchSchema, component: Page });
